"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Footer() {
    return `
<footer class="w-full h-16 border-t border-solid border-line flex items-center justify-center text-caption1">
  <a href="https://github.com/y-baaam" class="text-muted hover:text-white-200">@ young beom</a>
</footer>
`;
}
exports.default = Footer;
